import { format as dateFnsFormat, parseISO } from 'date-fns'

export function formatDate(value?: string | Date | null, fmt = 'dd-MM-yyyy'): string {
  if (!value) return ''
  const d = typeof value === 'string' ? parseISO(value) : value
  return dateFnsFormat(d, fmt)
}
